
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { supplierCheckKuaJiBao } from "@/service/supplier-meta/api";
@Component({})
export default class KuajingbaoCheckInfo extends Vue {
  @Prop() sourceType!: number;
  @Prop() url!: string;
  @Prop({ required: false, default: true }) auto?: boolean;

  text = "";
  type = "";
  checkTimer = 0;
  checking = false;
  @Watch("url")
  handleUrlChange() {
    clearTimeout(this.checkTimer);
    if (!this.auto) {
      return;
    }
    this.checkTimer = window.setTimeout(() => {
      this.check();
    }, 100);
  }
  created() {
    this.check();
  }
  async check() {
    const isUrl = /^http[s]?:\/\/.+$/.test(this.url);
    if (this.url && isUrl && this.sourceType !== undefined) {
      this.text = "检测中...";
      this.type = "info";
      this.checking = true;
      const res = await supplierCheckKuaJiBao({
        shopUrl: this.url,
        sourceType: this.sourceType,
      });
      setTimeout(() => {
        this.checking = false;
      });
      if (res.isSuccess && res.result) {
        this.text = "已开通跨境宝";
        this.type = "";
      } else {
        this.text = "未开通跨境宝";
        this.type = "info";
      }
    } else {
      this.text = "";
      this.type = "";
    }
  }
}
